import { IEnkLoggedInUser } from "../../auth/auth-interfaces"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import { EnkIWPServerAuth } from "../../api/api-iwp-server"
import { loginResultToUser } from "../../api/api-utils"
import { useAuth } from "../../auth/use-auth"

export function EnkGroupSelectionButton(props: { user: IEnkLoggedInUser | null }) {
  const { user } = props
  const { onGroupChanged, onUserInfoChanged } = useAuth()
  const hasMultipleGroups = Boolean((user?.groups?.length || 0) > 1)
  const groupName = hasMultipleGroups ? user?.groups[0].description : ""

  async function handleGroupChange(groupId: number) {
    try {
      // Call API to set user group
      const userInfo = await EnkIWPServerAuth.setUserGroup(groupId)
      onUserInfoChanged(loginResultToUser(userInfo))
      onGroupChanged(groupId)
    } catch (error) {
      // Optionally handle error (e.g., show dialog)
      console.error("Failed to change group", error)
    }
  }

  return (
    <>
      {hasMultipleGroups && (
        <>
          <Menu as="div" className="relative">
            <MenuButton className="-m-1.5 flex items-center p-1.5">
              <span className="hidden lg:flex lg:items-center">
                <span aria-hidden="true" className="ml-4 text-sm font-semibold leading-6 text-gray-900">
                  {groupName}
                </span>
                <ChevronDownIcon aria-hidden="true" className="ml-2 h-5 w-5 text-gray-400" />
              </span>
            </MenuButton>
            <MenuItems
              transition
              className="absolute right-0 z-10 mt-2.5 w-40 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
            >
              {user?.groups.map((group) => (
                <MenuItem key={group.id}>
                  <div
                    onClick={() => {
                      void handleGroupChange(group.id)
                    }}
                    className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
                  >
                    {group.description}
                  </div>
                </MenuItem>
              ))}
            </MenuItems>
          </Menu>

          <div aria-hidden="true" className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200" />
        </>
      )}
    </>
  )
}
